import { useState } from 'react';
import { procurementApi } from '@/api/procurement.api';
import { useAppSelector } from '@/hooks/useAppSelector';
import { PageHeader } from '@/components/layout/PageHeader';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';

export function VendorPortalLoginPage() {
  const orgId = useAppSelector((s) => s.auth.user?.organizationId);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const requestLink = async () => {
    if (!orgId) {
      notify.error('Organization context required');
      return;
    }
    setLoading(true);
    try {
      await procurementApi.vendorPortalRequestLink(orgId, email);
      notify.success('If registered, a login link was sent (check server logs in dev)');
    } catch (err) {
      showApiError(err, 'Request link failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md pt-12">
      <PageHeader title="Vendor portal" description="Supplier self-service login" />
      <div className="card space-y-3 p-6">
        <Input label="Supplier email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <Button loading={loading} onClick={() => void requestLink()}>Send magic link</Button>
      </div>
    </div>
  );
}
